import Link from 'next/link';
import cn from 'classnames';
import { CornerDownLeft } from 'lucide-react';
import { RenderedLinkProps } from './types';

const RenderedLink = ({ link, title, isMobile }: RenderedLinkProps) => (
  <Link
    href={link}
    className="flex items-center gap-2 capitalize focus:outline-none"
  >
    {isMobile && <CornerDownLeft className="h-4 w-4 shrink-0" />}
    <span
      className={cn('underline underline-offset-1 ', {
        'tranisition text-gray-700/50 duration-150 ease-in-out hover:text-gray-700/100':
          !isMobile,
      })}
    >
      {title}
    </span>
  </Link>
);

export default RenderedLink;
